const profile = {
    title: 'Profile',
    userInfo: 'User Information',
    name: 'Name',
    email: 'Email',
    role: 'Role',
    tenant: 'Tenant',
    groups: 'Groups',
    security: 'Security',
    mfa: 'Multi-Factor Authentication (MFA)',
    mfaEnabled: 'Enabled',
    mfaDisabled: 'Disabled',
    lastVerified: 'Last Verified',
    backupCodesRemaining: 'Backup Codes Remaining',
    manageMfa: 'Manage MFA Settings',
    enableMfa: 'Enable MFA',
    mfaNotAvailable: 'MFA information could not be retrieved',
    activeSessions: 'Active Sessions',
    noActiveSessions: 'No active sessions',
    trustedDevices: 'Trusted Devices',
    noTrustedDevices: 'No trusted devices',
    manageInSettings: 'Manage in settings',
    unknownBrowser: 'Unknown browser',
    unnamedDevice: 'Unnamed Device',
    sessionDeleted: 'Session deleted successfully',
    deviceRemoved: 'Trusted device removed successfully',
    failedToDelete: 'Failed to delete session',
    failedToRemove: 'Failed to remove trusted device',
    failedToLoadProfile: 'Failed to load profile data',
    deleteSession: 'Delete session',
    removeTrustedDevice: 'Remove trusted device',
  };

export default profile;
